import {observable, computed, action, toJS} from 'mobx';
import queryString from 'query-string';
import {getIn} from '../utils';
import {Property} from './RentalObject';
import moment from 'moment';
import createSelector, {LruCacheObject} from 're-reselect';

class SearchResultItem {
  @observable content = {};

  constructor(content, navigation) { 
    this.content = content;
    this.navigation = navigation;
  }

  @computed get id() {
    return this.content.Id;
  }

  @computed get name() {
    return this.content.Name;
  }

  @computed get currencyName() {
    return getIn(this.content, ['Currency_Name'])
  }

  @computed get priceFromValue() {
    return this.content.RentalObjectOffer[0].PricePerTimeUnit;
  }

  @computed get timeUnitForPrice() {
    return getIn(this.content, ['PriceFromAllotmentTimeUnit_Name']);
  }

  @computed get pricePerTimeUnit() {
    return getIn(this.content, ['RentalObjectOffer', 0, 'PricePerTimeUnit']);
  }

  @computed get resultPriceFrom() {
    return getIn(this.content, ['ResultPriceFrom'], null);
  }

  @computed get businessUnitName() {
    return this.content.BusinessUnit_Name;
  }

  @computed get firstImageId() {
    return this.content.RentalObjectAttachment_firstImageId;
  }

  @computed get thumbnailUrl() {
    return this.navigation.thumbnailUrl(this.firstImageId); 
  }

  @computed get detailHref() {
    return this.navigation.hrefObjectDetails(this.id);
  }

  @computed get isObjectGroup() {
    return this.content.IsGroup;
  }

  @computed get lat() {
    return getIn(this.content, ['BusinessUnit_Latitude']);
  }

  @computed get lon() {
    return getIn(this.content, ['BusinessUnit_Longitude']);
  }

  @computed get parameters() {
    return getIn(this.content, ['RentalObjectRentalParameterValue'], []).map(o => {
      return new Property(o);
    })
  }

  hasParameter(name) {

  }
}

export class SearchResults {
  @observable content = [];

  constructor(navigation, api, organization, searchForm) {
    this.navigation = navigation;
    this.api = api;
    this.organization = organization;
    this.searchForm = searchForm;
  }

  _paramFilterFn = (item) => {
    const filterParams = this.searchForm.parameters;
    let result = true;
    for(let parameter of item.parameters) {
      if(parameter.value === null) {
        continue;
      }
      if(filterParams.has(parameter.name)) {
        switch(parameter.typeName) {
          case 'Enum':
            result = result && (
              filterParams.get(parameter.name).length === 0 || 
              filterParams.get(parameter.name).indexOf(parameter.value) !== -1
            );
            break;
          case 'String':
            result = result && (
              filterParams.get(parameter.name).length === 0 ||
              filterParams.get(parameter.name).indexOf(parameter.value) !== -1
            );
            break;
          case 'Integer':
            result = result && (
              filterParams.get(parameter.name).min <= parameter.value &&
              filterParams.get(parameter.name).max >= parameter.value
            );
            break;          
          case 'Float':
            result = result && (
              filterParams.get(parameter.name).min <= parameter.value &&
              filterParams.get(parameter.name).max >= parameter.value
            );
            break;  
          case 'Boolean':
            result = result && (
              filterParams.get(parameter.name) === undefined || 
              filterParams.get(parameter.name) === parameter.value
            );
            break;           
        }           
      }
    }
    return result;
  }

  @computed get filteredItems() {
    return this.items.filter(this._paramFilterFn);
  }

  @computed get items() {
    return this.content;
    //return this.content.map(o => new SearchResultItem(o, this.navigation));
  }

  async get({categoryId, organizationId, subcategoryId, businessUnitId, startDate, endDate, pageSize, pageNumber}) {
    let raw = await this.api.getSearchResults({
      rentalCategoryId: categoryId,
      organizationId: organizationId,
      rentalSubcategoryId: subcategoryId,
      businessUnitId: businessUnitId, 
      StartDate: startDate,
      EndDate: endDate, 
      pageSize,
      pageNumber,
    });
    return raw.map(o => new SearchResultItem(o, this.navigation));
  }
 
  @action.bound setItems(items) {
    this.content = items;
  }

  @action.bound addItems(items) {
    this.content.push(...items);
  }

  @action.bound async fetch({categoryId, organizationId, subcategoryId, businessUnitId, startDate, endDate, pageSize, pageNumber}) {
    this.setItems(await this.get({categoryId, organizationId, subcategoryId, businessUnitId, startDate, endDate, pageSize, pageNumber}))
  }

  cFetch = createSelector(
    [p => p],
    (p) => 
      this.fetch(p)
  )(
    ({categoryId, organizationId, subcategoryId, businessUnitId, startDate, endDate, pageSize, pageNumber}) => {
      return `${categoryId}@${organizationId}@${subcategoryId}@${businessUnitId}@${startDate}@${endDate}@${pageSize}@${pageNumber}`
    },
    {cacheObject: new LruCacheObject({cacheSize: 1}), }
  );  

  /*@action async load() {
    this.content = await this.api.getSearchResults({
      rentalCategoryId: this.scene.state.categoryId,
      organizationId: this.scene.state.organizationId,
      rentalSubcategoryId: this.scene.state.subcategoryId,
      businessUnitId: this.scene.state.businessUnitId, 
      StartDate: this.scene.state.startDate,
      EndDate: this.scene.state.endDate, 
    })*/
 

  async fetchRandomObjects({orgId, count}) {
    let foundObjects = (await this.api.getSearchResults({
      //rentalCategoryId: categoryId,
      organizationId: orgId,
      pageSize: 20,
      //rentalSubcategoryId: subcategoryId,
      //businessUnitId: businessUnitId, 
      StartDate: moment().toISOString(),
      EndDate: moment().add({days: 120}).toISOString(), 
    }))
    .map(o => new SearchResultItem(o, this.navigation))
    let resultList = [];
    const foundObjectsCount = foundObjects.length;
    for(let i = 0; i < Math.min(count, foundObjectsCount); i++) {
      resultList.push(foundObjects.splice(Math.floor(Math.random() * foundObjects.length), 1)[0]);
    }
    return resultList;
  }  

  cFetchRandomObjects = createSelector(
    [p => p],
    (p) => this.fetchRandomObjects(p)
  )(
    ({orgId, count}) => 
      `${orgId}@${count}`,
    {cacheObject: new LruCacheObject({cacheSize: 1}), }
  );   
}


// WEBPACK FOOTER //
// ./src/model/SearchResults.js